// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ZMPUNxoJ-ufSsdy6FOMOR"};